import { render, staticRenderFns } from "./RemoveButton.vue?vue&type=template&id=706b0518&scoped=true&"
import script from "./RemoveButton.vue?vue&type=script&lang=js&"
export * from "./RemoveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b0518",
  null
  
)

export default component.exports